enum EOrderStatus {
  IN_REVIEW = 1,
  READY = 2,
}

export default EOrderStatus
